import { useState } from 'react';
import { handleImageChange } from "../../../../utilities/handleFunctions/HandelImageChange"
import { maxDate, minDate } from "../../../../utilities/validations/dateValidations";
import { SubmitButtonSpiner } from '../../../../components/buttons/SubmitButton';
import UserSampleImg from '../../../../assets/defaults/user0-img.jpg';


export default function AdminDashForm({ role, id, adminImage, register, handleSubmit, onSubmit, formState: { errors }, setValue, loading, formattedBirthDate, toast, firstName, lastName, email, mobilePhone }) {
    const [image, setImage] = useState(UserSampleImg);

    return (
        <form className='d-flex flex-column flex-md-row gap-2'
            onSubmit={handleSubmit(onSubmit)}>
            <div className="profile-image-container position-relative mt-4 my-md-auto mx-auto">
                <img crossOrigin="anonymous" className="profile-image"
                    src={!adminImage ? image : (image !== UserSampleImg ? image : adminImage)}
                    alt={`${role}_${id}_Img`} />
                <h6 className="profile-change-text border text-center">تغيير الصورة</h6>
                <input
                    // disabled
                    className="opacity-0 profile-image-input"
                    type="file"
                    accept="image/jpeg"
                    onChange={(e) => handleImageChange(e, setValue, setImage, toast)}
                />
            </div>
            <div className="d-flex flex-column col-11 col-md-8 mx-auto my-4 gap-3">
                <div className="input-group input-group-sm">
                    <span className="input-group-text">الاسم الأول</span>
                    <input
                        className={`form-control ${errors.firstName && "border border-danger"}`} type="text"
                        placeholder="الاسم الأول"
                        defaultValue={firstName}
                        onChange={(e) => { setValue("firstName", e.target.value) }}
                        {...register("firstName", { required: true, minLength: 3 })} />
                    {errors.firstName && <p className='errors-msg'>الاسم مطلوب أكبر من ٣ أحرف</p>}
                </div>
                <div className="input-group input-group-sm">
                    <span className="input-group-text">الاسم الأخير</span>
                    <input
                        className={`form-control ${errors.lastName && "border border-danger"}`} type="text"
                        placeholder="الاسم الأخير"
                        defaultValue={lastName}
                        onChange={(e) => { setValue("lastName", e.target.value) }}
                        {...register("lastName", { required: true, minLength: 3 })} />
                    {errors.lastName && <p className='errors-msg'>الاسم مطلوب أكبر من ٣ أحرف</p>}
                </div>
                <div className="input-group input-group-sm">
                    <span className="input-group-text" >البريد الالكتروني</span>
                    <input
                        className='form-control'
                        type="text"
                        placeholder="البريد الالكتروني"
                        defaultValue={email}
                        onChange={(e) => { setValue("email", e.target.value) }}
                        {...register("email", { required: true })} />
                    {errors.email && <p className='errors-msg'>أدخل البريدالالكتروني</p>}
                </div>
                <div className="input-group input-group-sm">
                    <span className="input-group-text" >رقم الجوال</span>
                    <input
                        className='form-control text-start'
                        type="tel"
                        placeholder="05xxxxxxxx"
                        onChange={(e) => { setValue("mobilePhone", e.target.value) }}
                        defaultValue={mobilePhone}
                        {...register("mobilePhone", { required: true })} />
                    {errors.mobilePhone && <p className='errors-msg'>أدخل رقم الجوال الصحيح</p>}
                </div>
                <div className="input-group input-group-sm">
                    <span className="input-group-text" >تاريخ الميلاد</span>
                    <input
                        className='form-control text-start'
                        type="date"
                        placeholder="تاريخ الميلاد"
                        defaultValue={formattedBirthDate}
                        min={minDate}
                        max={maxDate}
                        onChange={(e) => { setValue("birthDate", e.target.value) }}

                    />
                    {errors.birthDate && <p className='errors-msg'>تاريخ الميلاد مطلوب</p>}
                </div>
                <input
                    className='form-control text-start'
                    type="hidden"
                    placeholder="المسؤولية"
                    value={role}
                    {...register("role")} disabled />
            </div>
            <SubmitButtonSpiner
                loading={loading}
                btnValue="تعديل"
            />
        </form>
    );
}